<template>
  <div>
  </div>
</template>

<script>
import { loginUtils } from '../../utils/auth'
export default {
  created () {
    console.log(this.$route)
    let state
    var url = document.location.toString()
    console.log(url)
    let para = url.split('?')[1] || ''
    console.log(para)
    let pathArr = para.split('&') || []
    console.log(pathArr)
    if (pathArr) {
      for (let item of pathArr) {
        console.log(item)
        if (item.startsWith('state=')) {
          state = item.slice(6)
        }
      }
      state = encodeURIComponent(state)
      console.log(state)
    }

    loginUtils.ssoLogin(state)
  }
}
</script>

<style>

</style>
